<template>
    <div>
        <s-toolbar dense dark color="#7b7b7b" @save="savePersons()" @close="close()" save close label="Grupos"></s-toolbar>
        <v-card class="pa-md-4 mx-lg-auto">
            <v-row>
                <v-col lg="12" cols="12" style="padding-bottom: 10px;">
                    <v-card-title class="primary--text">Datos Generales</v-card-title>
                    <v-card-text>
                        <v-container grid-list-xs class="ma-0 pa-0">
                            <v-row>					
                                <v-col cols="4" lg="4" md="6" sm="12">
                                    <s-text
                                        label="Nombre del Grupo"
                                        v-model="item.PggNameGroup"
                                        ref="txtNombre"
                                    ></s-text>
                                </v-col>

                                <v-col cols="4" lg="4" md="6" sm="12">
                                    <s-select-definition
                                        label="Estado"
                                        v-model="item.PggStatus"
                                        :def="1154"
                                    ></s-select-definition>
                                </v-col>
                                <v-col cols="4" lg="3" md="6" sm="12">
                                    <s-select-definition
                                    label="Turno"
                                        v-model="item.TypeTurn"
                                        :def="1278">                            
                                    </s-select-definition>
                                </v-col>
                                <v-col cols="4" lg="3" md="6" sm="12">
                                    <s-select-definition
                                        label="Zonas de Trabajo"
                                        v-model="item.TypeZoneWork"
                                        :def="1445">                            
                                    </s-select-definition>
                                </v-col>
                            </v-row>
                                <!--Mostrar Grupos Produccion-->
                            <v-row class="pt-3 pr-3 pl-3">
                                <h3>Detalle de Grupo</h3>
                                <v-spacer></v-spacer>
                                <v-btn rounded fab x-small @click="addItemGP()"
                                    ><i class="fas fa-plus"></i
                                ></v-btn>
                            </v-row>
                                <v-divider></v-divider>
                            <v-container>
                                <v-row>
                                    <v-col cols="4" lg="4" md="6" sm="12">                                
                                        <s-toolbar-person
                                            v-model="item.PrsDocumentNumber"
                                            @returnPerson="hadReturnPerson($event, item)"
                                            ref="focusPrsDocument"
                                            noCamera
                                            noEdit
                                        />
                                    </v-col>
                                    <v-col cols="4" lg="4" md="6" sm="12">
                                        <s-text
                                            label="Nombres"
                                            v-model.trim="newPerson.PgdName"
                                            ref="focusPgdName"
                                        ></s-text>
                                    </v-col>
                                    <v-col cols="4" lg="4" md="6" sm="12">
                                        <s-text
                                            label="Apellidos"
                                            v-model.trim="newPerson.PgdLastName"
                                        ></s-text>
                                    </v-col>
                                    <v-col cols="4" lg="4" md="6" sm="12">
                                        <s-text
                                            label="DNI"
                                            v-model.trim="newPerson.PrsDocumentNumber"
                                        ></s-text>
                                    </v-col>

                                </v-row>
                                <v-row>
                                    <v-col class="pl-0 pt-0">
                                        <v-data-table
                                            dense
                                            :headers="headerProductionGroup"
                                            :items="itemsDataPG"
                                            hide-default-footer
                                            :items-per-page="-1"
                                            disable-sort
                                        >
                                            <template v-slot:item.Actions="{ item }">
                                                <v-btn
                                                    @click="clickDeleteItemGP(item)"
                                                    x-small
                                                    block
                                                    rounded
                                                    color="error"
                                                >
                                                <v-icon style="font-size: 16px !important"
                                                >mdi-close</v-icon
                                                >
                                                </v-btn>
                                            </template>
                                        </v-data-table>
                                    </v-col>
                                </v-row>
                            </v-container>                           
                        </v-container>
                    </v-card-text>
                </v-col>
            </v-row>
        </v-card>

    </div>
</template>

<script>
    import SToolbarPerson from "@/components/Utils/Person/sToolbarPerson";
    import _PackingGroup from "@/services/FrozenProduction/FrzPackingGroupService.js"; 
    
    export default {
        components: {SToolbarPerson},
        props:{
            value:{
                required: false,
                default: -1,
            },
            selectGroup:{
                required: false,
                default: Array,
            }
        },
        data()
        {
            return {
                headerProductionGroup: "",               
                headerProductionGroup: [
                    { text:"item", value :"Line"},
                    { text: "Nombre", value: "PgdName"},
                    { text: "Apellidos", value: "PgdLastName"},
                    { text: "dni", value: "PrsDocumentNumber"},
                    { text: "", value: "Actions" },
                ],
                newPerson: {},
                itemsDataPG:[],
                itemsDeletePG: [],
                item: {},
            }
        },
        methods:
        {
            close()
            {
                this.$emit("close");     
            },
            savePersons() {
                if(this.item.PggNameGroup == "")
                {
                    this.$fun.alert("Ingrese el nombre", "warning");
                    this.$refs.txtNombre.focus();
                    return;
                }
               
                if(this.itemsDataPG.length <= 0 ){
                    this.$fun.alert("Grupo debe tener Integrantes", "warning");
                    this.$refs.focusPrsDocument.focus();
                    return;
                }
                
                this.itemsDataPGAdd = [...this.itemsDataPG, ...this.itemsDeletePG];

                this.item.frzPackingGroupDetailList = this.itemsDataPGAdd;
                this.item.UsrCreateID = this.$fun.getUserID();  
                this.item.UsrUpdateID = this.$fun.getUserID();

                this.$fun.alert("Estas seguro de guardar?", "question").then((r) => {
                    if(r.value){
                
                        _PackingGroup.save(this.item, this.$fun.getUserID()).then((r) => {
                        if (r.status == 200) {
                            this.$fun.alert("Registrado correctamente", "success");
                            this.$emit("close");

                            this.itemsDataPG = []
                        }
                        });
                    }
                })                
            },
            addItemGP(){
                let existPerson = false;
                this.itemsDataPG.forEach(element => {
                    if(element.PrsDocumentNumber == this.newPerson.PrsDocumentNumber){
                        existPerson = true;
                        console.log('trabajador existe',existPerson)
                    }
                });
                if (existPerson){
                    this.$fun.alert("Trabajador ya Ingresado", "warning");
                    return ;
                }
                 if (!this.newPerson.PgdName) {
                    this.$refs.focusPgdName.error("Debe ingresar el nombre de un trabajador");
                    return;
                 } else {

                    this.newPerson.Line = this.itemsDataPG.length + 1;
                    this.newPerson.SecStatus = 1;
                    this.itemsDataPG.push({...this.newPerson});
                    
                    this.newPerson = {};

                    this.PgdName = "";

                    this.$refs.focusPgdName.focus();
                    
                    
                }
            },
            hadReturnPerson(item)
            {                  
                if (item != null) {
                    this.newPerson.PgdName = item.NtpName.trim();
                    this.newPerson.PgdLastName = item.NtpPaternalSurname.trim() +" "+ item.NtpMaternalSurname.trim();
                    this.newPerson.PrsDocumentNumber = item.PrsDocumentNumber;
                    
                    //this.newPerson.PgdID = item.PgdID;

                    this.newPerson.PrsID = item.PrsID;
                    this.newPerson.NtpID = item.NtpID;
                    this.newPerson.CtrID = item.CtrID;
                    this.newPerson.WrkID = item.WkrID;
                }                              
            },
 
            clickDeleteItemGP(item) {                
                this.itemsDataPG = this.itemsDataPG.filter(
                    (x) => {
                    return x.Line != item.Line
                    }
                );
                item.SecStatus = 0;
                if(item.PggID > 0)
                {
                    this.itemsDeletePG.push({ ...item} );                    
                }
                
            },
            getdataPersons()
            {
                this.item = {}
                if(this.value > 0 || this.value != undefined){

                    if(this.selectGroup.length > 0)
                    {   
                        this.item = this.selectGroup[0];
                    }
                    this.itemsDataPG = []


                    _PackingGroup.listdetail({ PggID: this.value  }, this.$fun.getUserID())
                        .then((r) => {
                            if (r.status == 200) {
                                r.data.forEach((el, index) => {
                                    el.Line = index + 1;
                                });                        

                                this.itemsDataPG = r.data;
                            }
                        
                        })
                }
            }
        },
        watch:{
            value(){
                this.getdataPersons();
            }
        }, 
        created(){
            this.getdataPersons();
        },
    }
</script>